<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Frederick Pangbourne is a short story and horror author with five anthologies currently out in publication. His stories have been featured in numerous magazines, anthologies, and on podcasts. A former Marine Corps veteran and retired correctional officer, he now resides in Florida where he continues to write and relax.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?6afb13d0